import { search } from './instantsearch';

search.start();
